import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-message-in',
  templateUrl: './icon-message-in.component.html',
  styleUrls: ['./icon-message-in.component.scss']
})
export class IconMessageInComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
